/**
 * UI store — interfeysning kichik holatlari (sidebar collapsed, va h.k.)
 *
 * Persistence: localStorage (foydalanuvchi sozlamalarini eslab qoladi).
 */

import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';

interface UiState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (v: boolean) => void;
}

export const useUiStore = create<UiState>()(
  devtools(
    persist(
      (set) => ({
        sidebarCollapsed: false,
        toggleSidebar: () => {
          set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed }));
        },
        setSidebarCollapsed: (v) => {
          set({ sidebarCollapsed: v });
        },
      }),
      {
        name: 'avtofix-ui',
        storage: createJSONStorage(() => localStorage),
      },
    ),
    { name: 'UiStore' },
  ),
);
